module.exports = __webpack_public_path__ + "img/iocn-4.6ca6d941.png";